import Swiper, { Autoplay, Mousewheel, Navigation, Pagination, Scrollbar } from "swiper";
import Choices from 'choices.js';

Swiper.use([Autoplay, Mousewheel, Navigation, Pagination, Scrollbar]);

const mobileBreakpoint = 768;

window.$ = window.jQuery = jQuery;

document.addEventListener("DOMContentLoaded", function () {

	/***********************************
	 MAIN
	***********************************/
	let mainHandler = {

		init: function () {
			this.mainNav();
			this.customForms();
			this.filterForms();
		},

		mainNav: function () {

			/** BURGER TOGGLE MENU **/
			let $buttonBurger = document.querySelector('.btn--toggle-menu');
			let $navMain = document.querySelector('.nav--main');
			let $navMainUL = $navMain.querySelector('ul');
			if (!$buttonBurger) {
				return;
			}

			function closeNav() {
				if ($buttonBurger.classList.contains('opened')) {
					$buttonBurger.classList.remove('opened');
					$buttonBurger.classList.add('closed');
					$navMain.classList.remove('opened');
				}
			}

			// Trigger click-outside to close
			document.addEventListener('click', (e) => {
				if ($buttonBurger.classList.contains('opened') && e.target !== $navMainUL && !$navMainUL.contains(e.target) && e.target !== $buttonBurger && !$buttonBurger.contains(e.target)) {
					closeNav();
				}
			});

			// Trigger "esc" key to close
			document.addEventListener('keydown', (e) => {
				if (e.key === "Escape") {
					closeNav();
				}
			});

			let toggleBurger = function (e) {
				/* Toggle Button */
				if ($buttonBurger.classList.contains('opened')) {
					$buttonBurger.classList.remove('opened');
					$buttonBurger.classList.add('closed');
				} else {
					$buttonBurger.classList.add('opened');
					$buttonBurger.classList.remove('closed');
				}
				/* Toggle Nav wrapper */
				$navMain.classList.toggle('opened');
				// Close all Submenus
				let $submenus = $navMain.querySelectorAll('.has-megamenu, .has-submenu, .header--account');
				for (let i = 0; i < $submenus.length; i++) {
					let $submenu = $submenus.item(i);
					$submenu.classList.remove('opened', 'visible');
				}

				if ($buttonBurger.classList.contains('opened')) {
					// disableBodyScroll(menuBS);
				} else {
					// enableBodyScroll(menuBS);
				}
			}

			$buttonBurger.addEventListener('click', toggleBurger, false);

		},

		customForms: function () {

			// MAIN SEARCH
			let $search = document.querySelector('.search--main');
			let $btnToggleSearch = document.querySelector('.btn--toggle-search');

			$btnToggleSearch.addEventListener('click', function () {
				$search.classList.toggle('visible')
			});

			/***********************************
			 SELECT
			***********************************/
			let $selects = document.querySelectorAll('select.choices, select.wpcf7-select');
			if ($selects) {

				Array.prototype.forEach.call($selects, function ($select) {
					let choices = new Choices($select, {
						// placeholderValue: $select.dataset.placeholder,
						// placeholder: false,
						searchEnabled: false,
						itemSelectText: ''
					});
					// choices.passedElement.element.addEventListener('change', function(event){
					// 	//alert(event.detail.value);
					// }, false);
				});


			};

			/***********************************
			 QUANTITY
			***********************************/
			let $quantityFields = document.querySelectorAll('.input--field.quantity');
			if ($quantityFields) {
				Array.prototype.forEach.call($quantityFields, function ($quantityField, i) {
					let qtMinus = $quantityField.querySelector('.input--qt-minus');
					let qtPlus = $quantityField.querySelector('.input--qt-plus');
					let qtInput = $quantityField.querySelector('.input--qt input');

					qtMinus.addEventListener('click', () => {
						let inputValue = parseInt(qtInput.value);
						if (inputValue > 0) {
							qtInput.value = inputValue - 1;
						} else {
							qtInput.value = 0;
						}
						qtInput.dispatchEvent(new Event('change', { 'bubbles': true }));
					});
					qtPlus.addEventListener('click', () => {
						let inputValue = parseInt(qtInput.value);
						qtInput.value = inputValue + 1;
						qtInput.dispatchEvent(new Event('change', { 'bubbles': true }));
					});
					qtInput.addEventListener('change', () => {
						$('[name="update_cart"]').trigger('click');
					})
				});

			}

		},

		filterForms: function () {
			if (document.querySelectorAll('#filter-form').length > 0) {
				let form = document.querySelector('#filter-form');
				form.querySelectorAll('select').forEach((select) => {
					select.addEventListener('change', () => {
						form.submit();
					});
				});
			}
		}



	}
	mainHandler.init();

	/***********************************
	 HOME
	***********************************/
	let homeHandler = {

		init: function () {
			this.swiperFeatured();
			this.swiperTopSales();
			this.swiperNewProducts();

		},

		swiperFeatured: function () {
			let sliderID = '.slider--home-featured';

			const swiperTopProducts = new Swiper(sliderID + ' .slider', {

				wrapperClass: 'wrapper',
				slideClass: 'slide',
				// Optional parameters
				// direction: 'vertical',
				loop: true,
				threshold: 20,
				autoplay: {
					delay: 5000,
				},

				spaceBetween: 0,

				// slidesPerView: 1,

				// If we need pagination
				pagination: {
					el: sliderID + ' .slider-pagination',
					type: 'bullets',
					clickable: true,
					bulletActiveClass: 'active'
				},

				// Navigation arrows
				// navigation: {
				// 	prevEl: sliderID + ' .slider-navigation .nav-prev',
				//   	nextEl: sliderID + ' .slider-navigation .nav-next'
				// },

				// And if we need scrollbar
				// scrollbar: {
				//   el: '.swiper-scrollbar',
				// },
			});
		},

		swiperTopSales: function () {

			let sliderID = '.slider--top-products';

			const swiperTopProducts = new Swiper(sliderID + ' .slider', {

				wrapperClass: 'wrapper',
				slideClass: 'slide',
				// Optional parameters
				// direction: 'vertical',
				// loopedSlides: 2,
				loop: true,
				threshold: 20,
				slidesPerView: 1,
				spaceBetween: 20,

				breakpoints: {
					// when window width is >= 320px
					320: {
						slidesPerView: 1,
						spaceBetween: 20,
					},
					// when window width is >= 480px
					480: {
						slidesPerView: 2,
						spaceBetween: 20
					},
					// when window width is >= 640px
					640: {
						slidesPerView: 4,
						spaceBetween: 40
					}
				},

				// If we need pagination
				// pagination: {
				//   el: swiperID + ' .pagination',
				// },

				// Navigation arrows
				navigation: {
					prevEl: sliderID + ' .slider-navigation .btn--slider-prev',
					nextEl: sliderID + ' .slider-navigation .btn--slider-next'
				},

				// And if we need scrollbar
				// scrollbar: {
				//   el: '.swiper-scrollbar',
				// },
			});

		},

		swiperNewProducts: function () {

			let sliderID = '.slider--new-products';

			const swiperNewProducts = new Swiper(sliderID + ' .slider', {

				wrapperClass: 'wrapper',
				slideClass: 'slide',
				// Optional parameters
				// direction: 'vertical',
				// loopedSlides: 2,
				loop: true,
				threshold: 20,
				slidesPerView: 1,
				spaceBetween: 20,

				breakpoints: {
					// when window width is >= 320px
					320: {
						slidesPerView: 1,
						spaceBetween: 20,
					},
					// when window width is >= 480px
					480: {
						slidesPerView: 2,
						spaceBetween: 20
					},
					// when window width is >= 640px
					640: {
						slidesPerView: 4,
						spaceBetween: 40
					}
				},

				// If we need pagination
				// pagination: {
				//   el: swiperID + ' .pagination',
				// },

				// Navigation arrows
				navigation: {
					prevEl: sliderID + ' .slider-navigation .btn--slider-prev',
					nextEl: sliderID + ' .slider-navigation .btn--slider-next'
				},

				// And if we need scrollbar
				// scrollbar: {
				//   el: '.swiper-scrollbar',
				// },
			});

		}

	}
	if (document.querySelector('#home'))
		homeHandler.init();


	/***********************************
	 SINGLE PRODUCT
	***********************************/
	let productHandler = {

		init: function () {
			this.swiperProductGallery();
			this.visitCard();
		},

		swiperProductGallery: function () {
			let $productGallery;
			let $productThumbs;

			// Thumbs
			$productThumbs = new Swiper('.product--single-images .gallery-thumbs .slider', {
				speed: 650,
				direction: 'horizontal',
				//slidesPerView: 5,
				slidesPerView: 'auto',
				//slidesPerGroup: 5,
				//centeredSlides: true,
				spaceBetween: 15,
				// snapOnRelease: true,
				//freeModeSticky: true,
				//freeMode: true,
				slideToClickedSlide: true,
				loop: false,
				threshold: 20,
				freeMode: {
					enabled: true,
					sticky: true,
				},
				breakpoints: {
					320: {
						direction: 'horizontal'
					},
					920: {
						direction: 'vertical',
						slidesPerView: 'auto',
						mousewheel: true,
					}
				},
				scrollbar: {
					el: '.swiper-scrollbar',
					draggable: true,
				},
				wrapperClass: 'wrapper',
				slideClass: 'slide',
				slideActiveClass: 'active',
				slidePrevClass: 'prev',
				slideDuplicatePrevClass: 'duplicate-prev',
				slideNextClass: 'next',
				slideDuplicateNextClass: 'duplicate-next'
			});

			// Main Gallery
			$productGallery = new Swiper('.product--single-images .gallery-main .slider', {
				speed: 650,
				slidesPerView: 1,
				slidesPerGroup: 1,
				loop: true,
				threshold: 20,
				//preloadImages: false,
				navigation: {
					prevEl: '.product--single-images .slider-navigation .btn--slider-prev',
					nextEl: '.product--single-images .slider-navigation .btn--slider-next'
				},
				updateOnImagesReady: false,
				wrapperClass: 'wrapper',
				slideClass: 'slide',
				slideActiveClass: 'active',
				slidePrevClass: 'prev',
				slideDuplicatePrevClass: 'duplicate-prev',
				slideNextClass: 'next',
				slideDuplicateNextClass: 'duplicate-next',
				on: {
					slideChangeTransitionEnd: function (swiper) {
						let currentSlide = swiper.realIndex;
						// console.log(currentSlide);
						$productThumbs.slideTo(currentSlide)
					}
				}
			});

			/** Thumbs Navigation **/
			let $thumbs = document.querySelectorAll('.gallery-thumbs .slide');
			if ($thumbs) {
				Array.prototype.forEach.call($thumbs, function ($thumb, i) {
					$thumb.addEventListener('click', () => {
						// console.log(i);
						let index = i + 1;
						$productGallery.slideTo(index)
						$productThumbs.slideTo(i)
					});
				});
			};
		},

		visitCard: () => {

			let $formVC = document.querySelector('.grid-visit-custom-fields');
			if (!$formVC) { return; }

			// Disable Add to Cart
			let $btn_addtocart = $formVC.parentNode.querySelector('.single_variation_wrap .single_add_to_cart_button.button');
			$btn_addtocart.classList.add('disabled');
			$btn_addtocart.disabled = true;

			let $steps = $formVC.querySelectorAll('.fieldset');

			// Global validation
			let inputs = $formVC.querySelectorAll('.form-row input[type="text"], .form-row input[type="email"], .form-row textarea, .form-row select');
			Array.prototype.forEach.call(inputs, (input) => {
				input.addEventListener('change', check_required_fields);
			});

			// Step validation
			Array.prototype.forEach.call($steps, function ($step, index) {
				let toggle = $step.querySelector('.fieldset__toggle');
				$step.dataset.step = index;
				toggle.addEventListener('click', (el) => {
					check_step(index)
				});
			});


			function check_step(index) {
				// check current step validation
				let currentStep = Array.from($steps).filter(node => node.classList.contains('current'));
				let currentStepIndex = currentStep[0].dataset.step;
				let lastStep = $steps[$steps.length - 1];
				let inputs = currentStep[0].querySelectorAll('.form-row input[type="text"], .form-row input[type="email"], .form-row textarea, .form-row select');

				let is_step_valid = true;
				let is_last_step = currentStep === lastStep;

				Array.prototype.forEach.call(inputs, (input) => {
					is_step_valid = toggle_input(input);
					input.addEventListener('change', toggle_input);
				});

				if (is_step_valid && !is_last_step) {
					// go to step
					goto_step(index)
				} else {
					// authorize returns to previous steps
					if (parseInt(currentStepIndex) > index) {
						goto_step(index)
					}
				}
			}

			function goto_step(index) {
				Array.prototype.forEach.call($steps, ($step) => {
					$step.classList.remove('current');
				});
				$steps[index].classList.add('current');
			}

			function toggle_input(input) {
				let state = false
				input = input.currentTarget ? input.currentTarget : input;

				if (!input.value) {
					input.closest('.form-row').classList.add('error');
					// return false;
				} else {
					input.closest('.form-row').classList.remove('error');
					state = true;
				}

				return state;
			}

			// Disable/enable Add to cart
			function check_required_fields() {
				let states = [];
				let is_valid = false;
				let inputs = $formVC.querySelectorAll('.form-row input[type="text"], .form-row input[type="email"], .form-row textarea, .form-row select');

				Array.prototype.forEach.call(inputs, (input) => {
					if (input.hasAttribute('required')) {
						if (input.value !== '') {
							states.push(true);
						} else {
							states.push(false);
						}
					}
				});

				is_valid = states.indexOf(false) > -1 ? false : true;
				$btn_addtocart.disabled = !is_valid;
			}

		}

	}
	if (document.querySelector('#tpl-product'))
		productHandler.init();


	/**
	 * WOOCOMMERCE - Cart
	 */
	let cartHandler = {
		init: function () {
			this.autoUpdate();
		},
		autoUpdate: function () {
			// $('.woocommerce').on('change', '.input-text.qty', function(){
			// 	$("[name='update_cart']").trigger("click");
			// });

			$(document.body).on('updated_cart_totals', function () {
				mainHandler.customForms();
			});
		}
	}
	if (document.querySelector('body.woocommerce-cart'))
		cartHandler.init();

	/**
	 * WOOCOMMERCE - My Account
	 */
	let myAccountHandler = {
		init: function () {
			this.accountNav();

			this.resizeHandler();
		},
		resizeHandler: function () {

			let vw = getViewportWidth();

			if (vw <= mobileBreakpoint) {
				this.shopTables();
			}

			window.addEventListener('resize', () => {
				vw = getViewportWidth();
				if (vw <= mobileBreakpoint) {
					this.shopTables();
				} else {
					let $labels = document.querySelectorAll('.col-label');
					if ($labels)
						Array.prototype.forEach.call($labels, function ($label) {
							$label.remove()
						});
				}

			});
		},
		accountNav: function () {

			let $nav = document.querySelector('.myaccount--wrap-navigation');
			let $navWrap = $nav.querySelector('.nav-wrap');
			let $navItems = $nav.querySelector('ul');
			let $toggleAccountNav = $nav.querySelector('.btn--account-nav');

			if ($toggleAccountNav) {

				// Trigger click-outside to close
				document.addEventListener('click', (e) => {
					if (e.target.matches('.btn--account-nav') || e.target.matches('.nav-wrap') || $navWrap.contains(e.target))
						return;

					if ($toggleAccountNav.classList.contains('opened'))
						toggleAccountNav();
				});

				$toggleAccountNav.addEventListener('click', () => {
					toggleAccountNav();
				});

			}

			function toggleAccountNav() {
				$toggleAccountNav.classList.toggle('opened');
				$navWrap.classList.toggle('opened');
				if ($toggleAccountNav.classList.contains('opened')) {
					let navHeight = $navItems.scrollHeight;
					$navWrap.style.maxHeight = navHeight + 'px';
				} else {
					$navWrap.style.maxHeight = '';
				}
			}
		},
		shopTables: function () {

			// Mobile custom layout
			let $tables = document.querySelectorAll('.shop_table_responsive');
			if ($tables) {

				let $labels = document.querySelectorAll('.col-label');

				if ($labels.length === 0) {
					Array.prototype.forEach.call($tables, function ($table) {
						let $tableHeads = $table.querySelectorAll('th');
						let $tableRows = $table.querySelectorAll('tr');
						let labels = [];

						Array.prototype.forEach.call($tableHeads, function ($tableHead) {
							let columnTitle = $tableHead.innerText;
							labels.push(columnTitle);
						});

						Array.prototype.forEach.call($tableRows, function ($tableRow) {
							let index = 0;
							let $tableCols = $tableRow.querySelectorAll('td');
							Array.prototype.forEach.call($tableCols, function ($tableCol) {
								let $columnLabel = document.createElement('span');
								$columnLabel.classList.add('col-label');
								$columnLabel.innerText = labels[index];
								$tableCol.insertBefore($columnLabel, $tableCol.firstChild);
								index++;
							});
						});
					});
				}

			}
		}
	}
	if (document.querySelector('body.woocommerce-account'))
		myAccountHandler.init();


});

/**
 * UTILITIES
 */
function getViewportWidth() {
	let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
	return viewportWidth;
}